import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { getBuildIdQuery, ILink } from '@ncg/data';
import { FooterNavModule, LinkModule, NavigationService, SettingsService, SocialLinksModule } from '@ncg/ui';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'ncg-footer',
    template: `
        <footer class="footer">
            <ng-container *ngIf="navigationService.getNavigation() | async as items">
                <ncg-footer-nav class="section footer-top" [items]="items" *ngIf="items?.length"></ncg-footer-nav>
            </ng-container>

            <div class="section footer-bottom" *ngIf="settingsService.get() | async as settings">
                <div class="container is-flex">
                    <div class="footer-bottom__logo">
                        <ncg-link [link]="settings.logoLink ?? logoLink">
                            <img
                                loading="lazy"
                                class="footer-logo"
                                [attr.src]="settings.logoImage?.url ?? '/assets/images/terminalen-logo.svg' + buildIdQuery"
                                [attr.alt]="settings.logoImage?.altText ?? 'Terminalen logo'"
                                [attr.width]="settings.logoImage?.width || '193'"
                                [attr.height]="settings.logoImage?.height || '46'"
                            />
                        </ncg-link>
                    </div>
                    <div class="footer-bottom__links">
                        <nav class="footer-bottom__navbar navbar" *ngIf="settings.footerLinks && settings.footerLinks.length">
                            <ncg-link
                                *ngFor="let link of settings.footerLinks"
                                [link]="link"
                                styleClass="footer-bottom__item footer-bottom__item--divider navbar-item"
                                >{{ link.name }}</ncg-link
                            >
                        </nav>
                        <div class="footer-bottom__copyright" *ngIf="settings.copyright">
                            <p>{{ settings.copyright }}</p>
                        </div>
                    </div>
                    <ncg-social-links
                        *ngIf="settings.socialLinks"
                        class="footer-bottom__social"
                        [socialLinks]="settings.socialLinks"
                    ></ncg-social-links>
                </div>
            </div>
        </footer>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    buildIdQuery = getBuildIdQuery();
    logoLink: ILink = {
        isExternal: false,
        name: '',
        url: '/',
    };

    constructor(
        public readonly navigationService: NavigationService,
        public readonly settingsService: SettingsService
    ) {}
}
@NgModule({
    declarations: [FooterComponent],
    imports: [CommonModule, SocialLinksModule, IconSpriteModule, FooterNavModule, LinkModule],
    exports: [FooterComponent],
})
export class FooterComponentModule {}
